import Type from '../../../redux/actions'
import {SET_LOSTPROVIDERTYPEDICTCASEPOOL} from "@actionTypes/actionTypes";

const casepool = (
  state = {},
  action
) => {
  const { roleKey, type, ...rest } = action;
  switch (type) {
    case Type.SET_LIST:
      return {
        ...state,
        [roleKey]: {
          ...state[roleKey],
          list: action.list,
          // pageSize: action.pageSize,
          total: action.total,
          // currentPage: action.currentPage
        }
      };
    case Type.SET_BATCHDOWNLOAD:
      return {
        ...state,
        [roleKey]: {
          ...state[roleKey],
          src: action.src,
        }
      };
    case Type.SET_SMSDATA:
      return {
        ...state,
        smsData: {
          court: action.court,
          caseNum: action.caseNum,
          docList: action.docList
        }
      }
    case Type.SET_STATUS_DICT:
      return {
        ...state,
        [roleKey]: {
          ...state[roleKey],
          [action.dictType]: action.statusList
        }
      }
    // 更新当前页面字段，保留当前数据其余字段，只更新传入的字段
    case Type.CURRENTFIELD:
      return {
        ...state,
        [roleKey]: {
          ...state[roleKey],
          ...rest,
        }
      }
    case Type.RESET_CASEPOOL:
      const newState = {...state};
      delete newState[roleKey];
      return {
        ...newState,
      }
    case Type.SET_LOSTPROVIDERTYPEDICTCASEPOOL:
      return {
        ...state,
        lostProviderTypeDict:action.payload
      }
    default:
      return state
  }
}

export default casepool
